import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'ngx-modal-confirmar-estoque',
  templateUrl: './modal-confirmar-estoque.component.html',
  styleUrls: ['./modal-confirmar-estoque.component.scss']
})
export class ModalConfirmarEstoqueComponent implements OnInit {

  @Input() qtdeElements: number;

  public customLogin = null;
  public descricao = 'Deseja realmente confirmar?'
  public subDescricao = 'Quantidade selecionados:';

  constructor(
    protected ref: NbDialogRef<ModalConfirmarEstoqueComponent>,
  ) { }

  ngOnInit() {
    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
  }

  saveCard() {
    this.ref.close(true);
  }

  closeModal() {
    this.ref.close(false);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

}